// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { watch16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-watch': IconWatch;
    }
}

/**
 * The icon component for the 'watch' icon
 */
export class IconWatch extends IconSvg {
    public constructor() {
        super(watch16X16);
    }
}

registerIconSvg('icon-watch', IconWatch);
export const iconWatchTag = 'nimble-icon-watch';
